import React from "react";
import { Star } from "lucide-react";

type Props = {
  value: number;
  onChange?: (val: number) => void;
  size?: number;
  readOnly?: boolean;
  className?: string;
};

export const RatingStars: React.FC<Props> = ({
  value,
  onChange,
  size = 18,
  readOnly,
  className,
}) => {
  const handleClick = (idx: number) => {
    if (readOnly || !onChange) return;
    onChange(idx);
  };

  return (
    <div className={className}>
      {[1, 2, 3, 4, 5].map((i) => (
        <button
          key={i}
          type="button"
          disabled={readOnly}
          onClick={() => handleClick(i)}
          className={`inline-flex items-center p-0.5 ${readOnly ? "cursor-default" : "cursor-pointer"}`}
        >
          <Star
            width={size}
            height={size}
            className={
              i <= value ? "text-yellow-500 fill-yellow-500" : "text-gray-300"
            }
          />
        </button>
      ))}
    </div>
  );
};

export default RatingStars;
